/**
 * Annotation-ink palette for SVG technical overlays (dimension lines,
 * radius leaders, baseline guides, warning strokes).
 *
 * Kept as plain hex strings because SVG presentation attributes
 * (`stroke="…"`, `fill="…"`) cannot reliably resolve `var(--name)`
 * across browsers.
 *
 * Where an entry mirrors a CSS variable in `styles/globals.css`, the
 * hex MUST equal the light-theme token value. The parity test in
 * `annotation-inks.test.ts` enforces this. Dark-theme SVG rendering
 * is out of scope — the canvas is always light.
 */
export const ANNOTATION = {
    /** Dimension leaders (width/height ticks). Mirrors `--primary`. */
    dim: '#0051ae',
    /** Corner radius / warm spacing measurement. Tuned orange, no CSS-var counterpart. */
    radius: '#c05800',
    /** Kontrastapmale / valid-state leader. Tuned for 1px-dashed-line legibility; not `--tertiary`. */
    ok: '#0b7a4a',
    /** Melnā mala / neg-kern / error leader. Mirrors `--destructive`. */
    warn: '#b3261e',
    /** Muted stroke (stroke-width annotations). Mirrors `--outline`. */
    muted: '#74777f',
    /** Baseline & grid guides. Mirrors `--outline-variant`. */
    guide: '#c4c6d0',
    /** On-surface ink (glyph fill). Mirrors `--on-surface`. */
    glyph: '#111418',
    /** Surface panel used as SVG fill (grid pattern). Mirrors `--surface-container-low`. */
    surfaceLow: '#f0f4fc'
} as const

export type AnnotationInk = keyof typeof ANNOTATION
